<template>
    <div class="ma-2 pa-2">
        <v-row dense>
            <v-col cols="12" :class=cbsa[0] v-bind:style="sbsa[0]">
                화재알리미 서비스 이용약관
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 1 조 (목적)
            </v-col>
            <v-row dense>
                <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                    본 약관은 (주)파이어룩스 (이하 "회사")가 제공하는 서비스인 '화재알리미' 서비스(이하 "서비스")의 이용과 관련하여 "회사"와 "이용자"와의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
                </v-col>
            </v-row>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 2 조 (정의)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① 이 약관에서 사용하는 용어의 정의는 다음 각호와 같습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                1.  '화재알리미 서비스'(이하 "서비스"라 한다)라 함은 "회사"가 운영하고 제공하는 서비스로, 이용자가 스마트폰을 이용하여 화재 장비의 제어를 편리하게 이용할 수 있도록 스마트폰에 설치하는 어플리케이션을 말합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                2. "전용 어플리케이션"(이하 "앱"이라 함)이라 함은 "서비스" 이용을 위해 단말기에 설치되는 어플리케이션을 말합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                3. "Bluetooth"란 근거리 무선 통신 기술을 말한다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                4. "이용자"란 "회사"의 정책에 따라 본 약관에 동의함으로써 본 "서비스"를 이용할 수 있는 고객을 말한다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② 본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계 법령 및 상관례에서 정하는 바에 의합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 3 조 (서비스 내용)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "회사"가 제공하는 "서비스"의 내용은 다음 각호와 같습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                1. 이용자가 "앱"를 통해 화재장비를 제어할 수 있는 기능
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② 이용자는 "회사"가 제공하는 "앱"을 설치하여 "서비스"를 이용할 수 있습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 4 조 (약관의 게시와 개정)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① 본 약관은 변경될 수 있으며, "회사"가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 초기화면에
                그 개정약관의 적용일자 15일 전부터 적용일자 전일까지 공지합니다.
                다만, 이용자에게 불리한 약관의 개정의 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지하며,
                일정기간 "서비스" 이용 시 동의창, SMS 등의 전자적 수단을 통해 따로 명확히 통지하도록 합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "회사"가 전항에 따라 개정약관을 공지 또는 통지하면서 이용자에게 30일 기간 내에 의사표시를 하지 않으면
                의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 이용자가 명시적으로
                거부의 의사표시를 하지 아니한 경우 이용자가 개정약관에 동의한 것으로 봅니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ③ 이용자가 개정약관의 적용에 동의하지 않는 경우 "회사"는 개정 약관의 내용을 적용할 수 없으며,
                이 경우 이용자는 이용계약을 해지할 수 있습니다.
                다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 "회사"는 이용계약을 해지할 수 있습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 5 조 (서비스 이용계약 체결 및 승낙, 거부, 유보)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① 이용계약은 이용자가 약관의 내용에 대하여 동의를 한 다음 "회사"가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "회사"는 이용자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다.
                다만, "회사"는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                1. 다른 사람의 "USIM"을 도용하여 신청하는 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                2. 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                3. 기타 이용자로서 부적절한 행위를 할 우려가 있다고 인정되거나 "서비스"를 정상적으로 이용할 수 없다고 합리적으로 판단되는 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ③ "회사"는 "서비스" 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
            </v-col>
        </v-row>


        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 6 조 (“회사”의 의무)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "회사"는 관련 법률과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 "서비스"를 제공하기 위하여 최선을 다합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "회사"는 이용자가 안전하게 "서비스"를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보취급방침을 공시하고 준수합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ③ "회사"는 "단말기"의 위조나 변조로 발생한 사고로 인하여 이용자에게 발생한 손해에 대하여 배상책임이 없습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ④ "회사"는 "서비스" 제공자로서 관련 법령에서 정하는 기간동안 개인정보를 보관합니다. 또한 보관중인 자료에 대하여 권리가 있는 자의 요청이 있는 경우 관련 자료를 제공할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ⑤ "회사"는 "서비스" 이용과 관련하여 이용자로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다.
                이용자가 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 이용자에게 처리과정 및 결과를 전달합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 7 조 (이용자의 의무)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① 이용자는 다음 행위를 하여서는 안 됩니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                1. 타인의 정보도용
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                2. "회사"가 게시한 정보의 변경
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                3. "회사"가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                4. "회사"와 기타 제3자의 저작권 등 지적재산권에 대한 침해
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                5. "회사" 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                6. "회사"의 동의 없이 영리를 목적으로 "서비스"를 사용하는 행위
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                7. "회사"의 "서비스"를 이용하여 얻은 정보를 "회사"의 사전 승낙 없이 복제, 유통, 상업적으로 이용
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                8. 기타 불법적이거나 부당한 행위
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② 이용자는 관련 법률, 본 약관의 규정, 이용안내 및 "서비스"와 관하여 공지한 주의사항,
                "회사"가 통지하는 사항 등을 준수하여야 하며, 기타 "회사"의 업무에 방해되는 행위를 하여서는 안 됩니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 8 조 ("서비스"의 중단 및 변경)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "서비스"는 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "회사"는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 "서비스"의 제공을 일시적으로 중단할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ③ "회사"는 운영상, 기술상 상당한 이유가 있는 경우 필요에 따라 제공하고 있는 "서비스"의 전부 또는 일부를 제한하거나 변경할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ④ "회사"는 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우 "서비스"의 전부 또는 일부를 제한하거나 변경할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ⑤ "회사"는 "서비스"의 제공에 필요한 경우 정기점검을 실시할 수 있으며,
                정기점검시간은 "서비스" 초기화면에 공지한 바에 따릅니다.
                다만, "회사"가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ⑥ "회사"는 "서비스"의 변경, 중단으로 발생하는 문제에 대해서 "회사"에 고의, 중과실이 없는 한 어떠한 책임도 지지 않습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 9 조 (이용자에 대한 통지)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "회사"가 이용자에 대한 통지는 본 약관에 별도 규정이 없는 한 단문 메시지 등 기타의 방법으로 할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "회사"는 이용자 전체에 대한 통지의 경우 15일 이상 "회사"의 게시판에 게시하거나 기타의 방법으로 통지할 수 있습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 10 조 (정보의 제공 및 광고의 게재)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "회사"는 "서비스"의 운영과 관련하여 다양한 정보 및 광고를 "서비스" 초기화면,
                홈페이지 공지사항이나 기타 등의 방법으로 이용자에게 제공할 수 있습니다.
                다만, 이용자는 관련 법률에 따른 거래관련 정보 및 고객문의 등에 대한 답변 등을 제외하고는
                언제든지 전자우편 등에 대해서 수신 거절을 할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② 제1항의 정보를 전화 및 E-mail 등에 의하여 전송하려고 하는 경우에는
                이용자의 사전 동의를 받아서 전송합니다. 다만, 이용자의 정보 및 고객문의 등에 대한 회신에 있어서는 제외됩니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 11 조 (권리의 귀속)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "서비스"에 대한 저작권 및 지적재산권은 "회사"에 귀속됩니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "회사"는 "서비스"와 관련하여 이용자에게 "회사"가 정한 이용조건에 따라
                "서비스" 등을 이용할 수 있는 이용권만을 부여하며, 이용자는 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 12 조 (이용제한 등)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "회사"는 다음과 같은 사유가 있는 경우, "서비스" 이용을 제한하거나 "서비스"의 이용계약을 해지할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                1. 이용자의 이용계약 신청에 승낙거부 사유가 있음이 확인된 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                2. 이용자가 "회사"가 제공하는 "서비스"를 그 목적에 벗어나거나 위배하여 이용한 것으로 확인된 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                3. 이용자가 다른 이용자 또는 기타 타인의 권리나 명예, 신용, 정당한 이익을 방해하거나 침해한 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                4. 이용자가 "회사"의 권리나 명예, 정당한 이익을 방해 또는 침해하거나 "회사"의 원활한 "서비스" 제공을 방해 하거나 방해하고자 시도한 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                5. 이용자가 사회의 안녕질서, 공공질서, 미풍양속에 위배되는 거래행위를 하거나 시도한 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                6. 기타 이용자가 법령 및 약관에 위배되는 행위를 한 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② 본 조에 따라 "서비스" 이용을 제한하거나 계약을 해지하는 경우에는 "회사"는 제9조 [이용자에 대한 통지]에 따라 통지합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ③ 이용자는 본 조에 따른 이용제한 등에 대해 "회사"가 정한 절차에 따라 이의신청을 할 수 있습니다.
                이 때 이의가 정당하다고 "회사"가 인정하는 경우 "회사"는 즉시 "서비스"의 이용을 재개합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 13 조 (개인정보보호 의무)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "회사"는 "정보통신망 이용촉진 및 정보보호 등에 관한 법률"(이하 "정통망법") 등
                관련 법률이 정하는 바에 따라 이용자의 개인정보를 보호하기 위해 노력합니다.
                개인정보의 보호 및 사용에 대해서는 관련 법률 및 "회사"의 개인정보취급방침이 적용됩니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "회사"가 이용자의 개인식별이 가능한 개인정보를 수집하는 때에는 반드시 해당 "이용자"의 동의를 받습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ③제공된 개인정보는 당해 이용자의 동의없이 목적 외의 이용이나 제3자에게 제공할 수 없으며,
                이에 대한 모든 책임은 "회사"가 집니다. 다만, 다음의 경우에는 예외로 합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                1. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                2. 도용방지를 위하여 본인확인에 필요한 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                3. 법률의 규정 또는 법률에 의하여 필요한 불가피한 사유가 있는 경우
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 14 조 (손해배상)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "이용자"는 본 약관의 규정을 위반함으로 인하여 "회사"에 손해가 발생하게 되는 경우,
                본 약관을 위반한 회원은 회사에 발생하는 모든 손해를 배상하여야 합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "이용자"가 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반행위로 인하여
                회사가 당해 "이용자" 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우
                당해 "이용자"는 자신의 책임과 비용으로 회사를 면책시켜야 하며,
                당해 "이용자"는 그로 인하여 회사에 발생한 모든 손해를 배상하여야 합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 15 조 (책임제한)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "회사"는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 관한 책임이 면제됩니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "회사"는 이용자의 귀책사유로 인한 "서비스" 이용의 장애에 대하여는 책임을 지지 않습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ③ "회사"는 이용자가 "서비스"를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며 서비스를 통하여 얻은 자료로 인한 손해 등에 대하여도 책임을 지지 않습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ④ "회사"는 이용자 상호간 또는 이용자와 제3자 상호간에 서비스를 매개로 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                제 16 조 (준거법 및 재판관할)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ① "회사"와 이용자 간 제기된 소송은 대한민국 법령을 준거법으로 합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ② "서비스" 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 민사소송법상의 관할법원에 소를 제기할 수 있습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                [부칙]
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                (시행일) 이 약관은 2024년 09월 01일부터 시행합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                상기 약관은 이용자 고지 없이 변경될 수 있습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[5] v-bind:style="sbsa[3]">
                (주)파이어룩스 | 대표이사 : 임정아 | 주소 : 충청북도 청주시 서원구 남이면 양촌4길 23-1
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" :class=cbsa[6] v-bind:style="sbsa[3]">
                <!-- 사업자등록번호 : 753-81-02469 | 이메일 : firelooks@firelooks.com | 고객센터 : 1588- -->
                사업자등록번호 : 753-81-02469 | 이메일 : firelooks@firelooks.com | 고객센터 : 031-478-8193
            </v-col>
        </v-row>
    </div>
</template>

<script setup>
import {
    onMounted,
    onUpdated,
} from "vue";
import {
    faLog,
    classBindsServiceAgreement,
    styleBindsServiceAgreement,
} from "../common/faCommon.js";

const cbsa = classBindsServiceAgreement;
const sbsa = styleBindsServiceAgreement;

onUpdated(() => {
    faLog(0, "[ServiceAgreement] [onUpdated]");
});

onMounted(() => {
    faLog(0, "[ServiceAgreement] [onMounted]");
});
</script>